import React from 'react';
import './style/DeliveryBlock.css'; // Путь к вашему CSS-файлу
import DeliveryImage from './store_pictures/DeliveryBlock1.jpg'; // Импорт изображения

const DeliveryBlock = () => {
  return (
    <div className="delivery-container-1">
      <div className="delivery-block" style={{ backgroundImage: `url(${DeliveryImage})` }}>
        <div className="delivery-info">
          <div className="delivery-time">с 8.00 до 22.00</div>
          <div className="delivery-text">Доставим в любую точку Города</div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryBlock;
